<script>
  import { Router, Link, Route } from 'svelte-navigator';
  import RouteTransition from '../RouteTransition.svelte';
  import { fly, blur } from 'svelte/transition';

  import {
    idTrappe,
    type,
    dimLongueur,
    dimLargeur,
    sensOuverture,
    fermeture,
    couleur,
    idBtnCoupeFeu,
    idBtnCoupeFeuPlafond,
    idBtnCoupeFeuPlafondResistance,
    idBtnCoupeFeuPlafondEpaisseur,
    idBtnCoupeFeuCloison,
    idBtnCoupeFeuCloisonResistance,
    idBtnCoupeFeuCloisonEpaisseur,
  } from '../stores.js';

  import ChoixTrappe from '../Pages/ChoixTrappe.svelte';
  import TitleNNumber from '../ComponentsInProcess/TitleNNumber.svelte';
  import BtnPage from '../ComponentsInProcess/btnPageMetalique.svelte';
  import BtnPageCoupeFeu from '../ComponentsInProcess/BtnPageCoupeFeu.svelte';
  import RangeSliderPlafond30min18mm from '../ComponentsInProcess/range-slider-5-plafond-30-18mm.svelte';
  import RangeSliderPlafond30min125mm from '../ComponentsInProcess/range-slider-5-plafond-30-125mm.svelte';
  import RangeSliderPlafond60min from '../ComponentsInProcess/range-slider-5-plafond-60.svelte';
  import RangeSliderPlafond90min from '../ComponentsInProcess/range-slider-5-plafond-90.svelte';
  import RangeSliderCloison30min from '../ComponentsInProcess/range-slider-5-cloison-30.svelte';
  import RangeSliderCloison90min from '../ComponentsInProcess/range-slider-5-cloison-90.svelte';
  import BtnInputPage from '../ComponentsInProcess/range-slider-1-metallique.svelte';
  export let idFiche;
  console.log(`idFiche ${idFiche}`);
</script>

{#if idFiche == 1}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu idFiche="{idFiche}" idBtn="1a" titre="{'Plafond'}" />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu idFiche="{idFiche}" idBtn="1b" titre="{'Cloison'}" />
    </div>
  </div>
{/if}

<!-- Cloison -->
{#if idFiche == '1b'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1b2a"
        titre="{'30 minutes'}"
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1b2b"
        titre="{'60 minutes'}"
      />
    </div>
    <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1b2c"
        titre="{'60 minutes cloison / plafond 30 min'}"
      />
    </div>
    <div in:fly="{{ delay: 500, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1b2d"
        titre="{'90 minutes'}"
      />
    </div>
  </div>
{/if}

<!-- Cloison - 30 min - Dimensions -->
{#if idFiche == '1b2a'}
  <RangeSliderCloison30min
    idBtn="1b2a3"
    idFiche="{idFiche}"
    titre="{'Longueur'}"
    soustitre="{'avec une l'}"
  />
{/if}
<!--  Cloison - 30 min - Dimensions - Côté d’ouverture -->
{#if idFiche == '1b2a3'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1b2a34"
        titre="{'Sur le côté de ' + $dimLongueur + ' mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1b2a34"
        titre="{'Sur le côté de ' + $dimLargeur + ' mm'}"
        soustitre=""
      />
    </div>
  </div>
{/if}
<!--  Cloison - 30 min - Dimensions - Côté d’ouverture -  Type de fermeture -->
{#if idFiche == '1b2a34'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1b2a345a"
        idFiche="{idFiche}"
        titre="{'Pousser / Lâcher'}"
      />
    </div>
    <div in:fly="{{ delay: 100, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1b2a345b"
        idFiche="{idFiche}"
        titre="{'Clé carré'}"
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1b2a345c"
        idFiche="{idFiche}"
        titre="{'Clé boite aux lettres'}"
      />
    </div>
  </div>
{/if}

<!-- Cloison - 60 min - Dimensions -->
{#if idFiche == '1b2b'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1b2b3"
        titre="{'300 x 300 mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ x: 200, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1b2b3"
        titre="{'400 x 400 mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ x: 300, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1b2b3"
        titre="{'500 x 500 mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ x: 400, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1b2b3"
        titre="{'600 x 600 mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ x: 500, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1b2b3"
        titre="{'800 (sens d’ouverture) x 600 mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ x: 600, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1b2b3"
        titre="{'1200 (sens d’ouverture) x 600 mm'}"
        soustitre=""
      />
    </div>
  </div>
  <div in:fly="{{ delay: 700, x: 100, duration: 800 }}">
    <p class="as-info-trappe">
      La trappe sélectionnée est disponible uniquement dans ces formats
    </p>
  </div>
  <br /><br />
  <br /><br />
  <br /><br />
{/if}
<!--  Cloison - 60 min - Dimensions -  Type de fermeture -->
{#if idFiche == '1b2b3'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ delay: 100, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1b2b34"
        idFiche="{idFiche}"
        titre="{'Clé carré'}"
      />
    </div>
  </div>
  <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
    <p class="as-info-trappe">
      La trappe sélectionnée est disponible en une seule fermeture
    </p>
  </div>
{/if}

<!-- Cloison - 60/30 min - Dimensions -->
{#if idFiche == '1b2c'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1b2c3"
        titre="{'200 x 200 mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ x: 200, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1b2c3"
        titre="{'300 x 300 mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ x: 300, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1b2c3"
        titre="{'400 x 400 mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ x: 400, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1b2c3"
        titre="{'500 x 500 mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ x: 500, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1b2c3"
        titre="{'600 x 600 mm'}"
        soustitre=""
      />
    </div>
  </div>
  <div in:fly="{{ delay: 600, x: 100, duration: 800 }}">
    <p class="as-info-trappe">
      La trappe sélectionnée est disponible en une seule fermeture
    </p>
  </div>
{/if}
<!--  Cloison - 60/30 min - Dimensions -  Type de fermeture -->
{#if idFiche == '1b2c3'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ delay: 100, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1b2c34"
        idFiche="{idFiche}"
        titre="{'Clé carré'}"
      />
    </div>
  </div>
  <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
    <p class="as-info-trappe">
      La trappe sélectionnée est disponible en une seule fermeture
    </p>
  </div>
{/if}

<!-- Cloison - 90 min - Dimensions -->
{#if idFiche == '1b2d'}
  <RangeSliderCloison90min
    idBtn="1b2d3"
    idFiche="{idFiche}"
    titre="{'Longueur'}"
    soustitre="{'avec une l'}"
  />
{/if}
<!--  Cloison - 30 min - Dimensions - Côté d’ouverture -->
{#if idFiche == '1b2d3'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1b2d34"
        titre="{'Sur le côté de ' + $dimLongueur + ' mm'}"
        soustitre=""
      />
    </div>
    <!-- <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
    <BtnPageCoupeFeu
      idFiche="{idFiche}"
      idBtn="1b2d34"
      titre="{'Sur le côté de ' + $dimLargeur + ' mm'}"
      soustitre=""
    />
  </div> -->
  </div>
{/if}
<!--  Cloison - 30 min - Dimensions - Côté d’ouverture -  Type de fermeture -->
{#if idFiche == '1b2d34'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1b2d345"
        idFiche="{idFiche}"
        titre="{'Aimantée'}"
      />
    </div>
  </div>
  <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
    <p class="as-info-trappe">
      La trappe sélectionnée est disponible en une seule fermeture
    </p>
  </div>
{/if}

<!-- Plafond -->
{#if idFiche == '1a'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2a"
        titre="{'30 minutes'}"
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2b"
        titre="{'60 minutes'}"
      />
    </div>
    <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2c"
        titre="{'90 minutes'}"
      />
    </div>
    <div in:fly="{{ delay: 500, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2d"
        titre="{'120 minutes'}"
      />
    </div>
  </div>
{/if}
<!-- Plafond - 30 min -->
{#if idFiche == '1a2a'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu idFiche="{idFiche}" idBtn="1a2a3a" titre="{'18 mm'}" />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2a3b"
        titre="{'2x 12,5 mm'}"
      />
    </div>
  </div>
{/if}
<!-- Plafond - 30 min  - 18mm -->
{#if idFiche == '1a2a3a'}
  <RangeSliderPlafond30min18mm
    idBtn="1a2a3a4"
    idFiche="{idFiche}"
    titre="{'Longueur'}"
    soustitre="{'avec une l'}"
  />
{/if}

<!-- Plafond - 30 min  - 18mm - Dimensions - Côté d’ouverture -->
{#if idFiche == '1a2a3a4'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2a3a45"
        titre="{'Sur le côté de ' + $dimLongueur + ' mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2a3a45"
        titre="{'Sur le côté de ' + $dimLargeur + ' mm'}"
        soustitre=""
      />
    </div>
  </div>
{/if}
<!-- Plafond - 30 min  - 18mm - Dimensions - Côté d’ouverture -  Type de fermeture -->
{#if idFiche == '1a2a3a45'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1a2a3a456a"
        idFiche="{idFiche}"
        titre="{'Pousser / Lâcher'}"
      />
    </div>
    <div in:fly="{{ delay: 100, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1a2a3a456b"
        idFiche="{idFiche}"
        titre="{'Clé carré'}"
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1a2a3a456c"
        idFiche="{idFiche}"
        titre="{'Clé boite aux lettres'}"
      />
    </div>
  </div>
{/if}

<!-- Plafond - 30 min  - 2x12.5mm  -->
{#if idFiche == '1a2a3b'}
  <RangeSliderPlafond30min125mm
    idBtn="1a2a3b4"
    idFiche="{idFiche}"
    titre="{'Longueur'}"
    soustitre="{'avec une l'}"
  />
{/if}
<!-- Plafond - 30 min  - 2x12.5mm - Dimensions - Côté d’ouverture -->
{#if idFiche == '1a2a3b4'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2a3b45"
        titre="{'Sur le côté de ' + $dimLongueur + ' mm'}"
        soustitre=""
      />
    </div>
  </div>
{/if}
<!-- Plafond - 30 min  - 2x12.5mm  - Dimensions - Côté d’ouverture -  Type de fermeture -->
{#if idFiche == '1a2a3b45'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1a2a3b456a"
        idFiche="{idFiche}"
        titre="{'Pousser / Lâcher'}"
      />
    </div>
    <div in:fly="{{ delay: 100, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1a2a3b456b"
        idFiche="{idFiche}"
        titre="{'Clé carré'}"
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1a2a3b456c"
        idFiche="{idFiche}"
        titre="{'Clé boite aux lettres'}"
      />
    </div>
  </div>
{/if}

<!-- Plafond - 60 min - epaisseur -->
<!-- {#if idFiche == '1a2b'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2b3"
        titre="{'2 x 15 mm'}"
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2b3"
        titre="{'2 x 18 mm'}"
      />
    </div>
  </div>
{/if} -->
<!-- Plafond - 60 min - epaisseur - Dimensions -->
<!-- {#if idFiche == '1a2b3'}
  <RangeSliderPlafond60min
    idBtn="1a2b34"
    idFiche="{idFiche}"
    titre="{'Longueur'}"
    soustitre="{'avec une l'}"
  />
{/if} -->

<!-- Plafond - 60 min - epaisseur  - Dimensions - Côté d’ouverture -->
<!-- {#if idFiche == '1a2b34'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2b345"
        titre="{'Sur le côté de ' + $dimLongueur + ' mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2b345"
        titre="{'Sur le côté de ' + $dimLargeur + ' mm'}"
        soustitre=""
      />
    </div>
  </div>
{/if} -->
<!-- Plafond - 60 min - epaisseur  - Dimensions - Côté d’ouverture -  Type de fermeture -->
<!-- {#if idFiche == '1a2b345'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1a2b3456a"
        idFiche="{idFiche}"
        titre="{'Pousser / Lâcher'}"
      />
    </div>
    <div in:fly="{{ delay: 100, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1a2b3456b"
        idFiche="{idFiche}"
        titre="{'Clé carré'}"
      />
    </div>
  </div>
{/if} -->

<!-- Plafond - 60 min - epaisseur -->
{#if idFiche == '1a2b'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2b3a"
        titre="{'2 x 15 mm'}"
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2b3b"
        titre="{'2 x 18 mm'}"
      />
    </div>
  </div>
{/if}
<!-- Plafond - 60 min - 2 x 15 mm - Dimensions -->
{#if idFiche == '1a2b3a'}
  <RangeSliderPlafond60min
    idBtn="1a2b3a4"
    idFiche="{idFiche}"
    titre="{'Longueur'}"
    soustitre="{'avec une l'}"
  />
{/if}

<!-- Plafond - 60 min - 2 x 15 mm  - Dimensions - Côté d’ouverture -->
{#if idFiche == '1a2b3a4'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2b3a45"
        titre="{'Sur le côté de ' + $dimLongueur + ' mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2b3a45"
        titre="{'Sur le côté de ' + $dimLargeur + ' mm'}"
        soustitre=""
      />
    </div>
  </div>
{/if}
<!-- Plafond - 60 min - 2 x 15 mm  - Dimensions - Côté d’ouverture -  Type de fermeture -->
{#if idFiche == '1a2b3a45'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1a2b3a456a"
        idFiche="{idFiche}"
        titre="{'Pousser / Lâcher'}"
      />
    </div>
    <div in:fly="{{ delay: 100, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1a2b3a456b"
        idFiche="{idFiche}"
        titre="{'Clé carré'}"
      />
    </div>
  </div>
{/if}

<!-- Plafond - 60 min - 2 x 18 mm - Dimensions -->
{#if idFiche == '1a2b3b'}
  <RangeSliderPlafond60min
    idBtn="1a2b3b4"
    idFiche="{idFiche}"
    titre="{'Longueur'}"
    soustitre="{'avec une l'}"
  />
{/if}

<!-- Plafond - 60 min - 2 x 18 mm  - Dimensions - Côté d’ouverture -->
{#if idFiche == '1a2b3b4'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2b3b45"
        titre="{'Sur le côté de ' + $dimLongueur + ' mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2b3b45"
        titre="{'Sur le côté de ' + $dimLargeur + ' mm'}"
        soustitre=""
      />
    </div>
  </div>
{/if}
<!-- Plafond - 60 min - 2 x 18 mm  - Dimensions - Côté d’ouverture -  Type de fermeture -->
{#if idFiche == '1a2b3b45'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1a2b3b456a"
        idFiche="{idFiche}"
        titre="{'Pousser / Lâcher'}"
      />
    </div>
    <div in:fly="{{ delay: 100, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1a2b3b456b"
        idFiche="{idFiche}"
        titre="{'Clé carré'}"
      />
    </div>
  </div>
{/if}

<!-- 90000000000 -->

<!-- Plafond - 90 min- epaisseur -->
{#if idFiche == '1a2c'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2c3"
        titre="{'2 x 20 mm'}"
      />
    </div>
  </div>
  <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
    <p class="as-info-trappe">
      La trappe sélectionnée est disponible en une seule épaisseur
    </p>
  </div>
{/if}
<!-- Plafond - 90 min- epaisseur - Dimensions -->
{#if idFiche == '1a2c3'}
  <RangeSliderPlafond90min
    idBtn="1a2c34"
    idFiche="{idFiche}"
    titre="{'Longueur'}"
    soustitre="{'avec une l'}"
  />
{/if}

<!-- Plafond - 90 min- epaisseur  - Dimensions - Côté d’ouverture -->
{#if idFiche == '1a2c34'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2c345"
        titre="{'Sur le côté de ' + $dimLongueur + ' mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2c345"
        titre="{'Sur le côté de ' + $dimLargeur + ' mm'}"
        soustitre=""
      />
    </div>
  </div>
{/if}
<!-- Plafond - 90 min- epaisseur  - Dimensions - Côté d’ouverture -  Type de fermeture -->
{#if idFiche == '1a2c345'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1a2c3456a"
        idFiche="{idFiche}"
        titre="{'Pousser / Lâcher'}"
      />
    </div>
    <div in:fly="{{ delay: 100, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1a2c3456b"
        idFiche="{idFiche}"
        titre="{'Clé carré'}"
      />
    </div>
  </div>
{/if}

<!-- 120000000000 -->

<!-- Plafond - 120 min - epaisseur -->
{#if idFiche == '1a2d'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2d3"
        titre="{'2 x 25 mm'}"
      />
    </div>
  </div>
  <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
    <p class="as-info-trappe">
      La trappe sélectionnée est disponible en une seule épaisseur
    </p>
  </div>
{/if}
<!-- Plafond - 120 min - epaisseur - Dimensions -->
{#if idFiche == '1a2d3'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2d34"
        titre="{'300 x 300 mm'}"
      />
    </div>
    <div in:fly="{{ x: 200, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2d34"
        titre="{'400 x 400 mm'}"
      />
    </div>
    <div in:fly="{{ x: 300, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2d34"
        titre="{'500 x 500 mm'}"
      />
    </div>
    <div in:fly="{{ x: 400, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2d34"
        titre="{'600 x 600 mm'}"
      />
    </div>
    <div in:fly="{{ x: 500, duration: 800 }}">
      <BtnPageCoupeFeu
        idFiche="{idFiche}"
        idBtn="1a2d34"
        titre="{'800 x 800 mm'}"
      />
    </div>
  </div>
  <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
    <p class="as-info-trappe">
      La trappe sélectionnée est disponible uniquement dans ces formats
    </p>
  </div>
{/if}

<!-- Plafond - 120 min - epaisseur  - Dimensions - Type de fermeture -->
{#if idFiche == '1a2d34'}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ delay: 0, x: 100, duration: 800 }}">
      <BtnPageCoupeFeu
        idBtn="1a2d345"
        idFiche="{idFiche}"
        titre="{'Clé carré'}"
      />
    </div>
  </div>
  <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
    <p class="as-info-trappe">
      La trappe sélectionnée est disponible en une seule fermeture
    </p>
  </div>
{/if}
